
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from '@uifabric/merge-styles';
import ToolbarLink from '../common/ToolbarLink';

const lineClasses = mergeStyleSets({
    line0: {
        backgroundColor: '#f4f4f4',
        padding: '1em'
    },

    line1: {
        backgroundColor: '#ffffff',
        padding: '1em'
    }
})

const classNames = mergeStyleSets({
    line: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },

    itemList: {
        borderTop: '1px solid #000000',
        paddingTop: '1em'
    },

    title: {
        fontWeight: 'bold'
    }
})

const Operation = ({
    col,
    expanded,
    operation,
    operationItems,
    operationItemList,
    toolbarItems
}) => {

    const operationItemsCount = operationItems.length;

    let lineClassName;
    if (col === 0) {
        lineClassName = lineClasses.line0;
    } else {
        lineClassName = lineClasses.line1;
    }

    let unit;
    if (operation.mj === 'm2') {
        unit = 'm²';
    } else {
        unit = 'm³';
    }

    return (
        <Stack className={lineClassName}>
            <Stack.Item className={classNames.line}>
                <Stack horizontal tokens={{childrenGap: 5}}>
                    <Stack.Item className={classNames.title}>{operation.title}</Stack.Item>
                    <Stack.Item>{unit}</Stack.Item>
                    <Stack.Item>({operationItemsCount})</Stack.Item>
                </Stack>
                <Stack>
                    <ToolbarLink
                        items={toolbarItems}
                    />
                </Stack>

            </Stack.Item>
            {expanded && <Stack horizontal className={classNames.itemList}>
                {operationItemList}
            </Stack>}
        </Stack>
    );
}

export default Operation;
